import { ActionLink } from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import { useCallback } from "react"

import styles from "../Onboarding.module.scss"
import { OnboardingPageTemplate } from "src/components"
import { usePolyglot } from "src/contexts"
import {
  useSources,
  useIsOnboardingSource,
} from "src/hooks"
import { AddDataSourceButtons } from "src/pages/Account/DataSource/AddDataSourceButtons"
import sharedStyles from "src/pages/Account/DataSource/DataSource.module.scss"
import { DataSourceComponent } from "src/pages/Account/DataSource/DataSourceComponent"
import { NightscoutDelay } from "src/pages/Account/DataSource/NightscoutDelay"
import { SourceConnectDialog } from "src/pages/Account/DataSource/SourceConnectDialog"
import { WarningDialogs } from "src/pages/Account/DataSource/WarningDialogs"

const settingsPolyglotPrefix = "pages.settings.data_source."
const onboardingPolyglotPrefix = "pages.onboarding.data_source."
const skip_Button = "skip-button"

export function DataSource() {
  const polyglot = usePolyglot()
  const [
    ,
    setIsOnboardingSource,
  ] = useIsOnboardingSource()

  // clear the value that tells us to resume onboarding after dexcom redirects
  const onNext = useCallback(
    () => {
      setIsOnboardingSource(false)
    },
    [setIsOnboardingSource],
  )

  const {
    data: sources,
  } = useSources()

  // TODO
  if (!sources) {
    return null
  }

  const source = sources[0]

  return (
    <OnboardingPageTemplate
      backRoutePath="/onboarding/get_started"
      title={polyglot.t(`${onboardingPolyglotPrefix}title`)}
    >
      <WarningDialogs source={source}/>
      <SourceConnectDialog>
        <div className={styles.container}>
          <div className={sharedStyles.disclaimer}>
            {polyglot.t(`${settingsPolyglotPrefix}disclaimer`)}
          </div>
          <hr className={sharedStyles.hr} />
          <div className={sharedStyles.textContainer}>
            <div className={sharedStyles.description}>
              {polyglot.t(`${settingsPolyglotPrefix}description`)}
            </div>
            {source ? (
              <DataSourceComponent source={source} />
            ) : (
              <>
                <div className={sharedStyles.description}>
                  {polyglot.t(`${settingsPolyglotPrefix}no_source_message`)}
                </div>
                <div className={sharedStyles.selectMessage}>
                  {polyglot.t(`${settingsPolyglotPrefix}select_data_source`)}
                </div>
              </>
            )}
          </div>
          {!source && (
            <AddDataSourceButtons isOnboarding />
          )}
          <NightscoutDelay />
          {source ? (
            <ActionLink
              asChild
              className={styles.submitCta}
              onClick={onNext}
            >
              <Link
                to="/onboarding/ranges"
                id="next-btn"
              >
                {polyglot.t(`${onboardingPolyglotPrefix}next_cta`)}
              </Link>
            </ActionLink>
          ) : (
            <ActionLink
              asChild
              stylePreset="secondary"
              className={styles.submitCta}
            >
              <Link
                to="/onboarding/ranges"
                onClick={onNext}
                id={skip_Button}
              >
                {polyglot.t(`${onboardingPolyglotPrefix}skip_cta`)}
              </Link>
            </ActionLink>
          )}
        </div>
      </SourceConnectDialog>
    </OnboardingPageTemplate>
  )
}
